import { render, staticRenderFns } from "./DianJin.vue?vue&type=template&id=7a882019&scoped=true&"
import script from "./DianJin.vue?vue&type=script&lang=js&"
export * from "./DianJin.vue?vue&type=script&lang=js&"
import style0 from "./DianJin.vue?vue&type=style&index=0&id=7a882019&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a882019",
  null
  
)

export default component.exports